import * as React from 'react';
import type { SVGProps } from 'react';
const SvgEmptyPie = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={142}
    height={142}
    fill="none"
    {...props}
  >
    <circle
      cx={71.334}
      cy={71.33}
      r={51.972}
      fill="#E9ECF0"
      transform="rotate(-90 71.334 71.33)"
    />
    <path
      fill="var(--dataviz-color-sequential-blue-scale04)"
      stroke="var(--dataviz-color-sequential-blue-scale05)"
      strokeDasharray="6 6"
      strokeWidth={2}
      d="M70.995 19.314c7.201 0 14.323 1.49 20.917 4.373a52.05 52.05 0 0 1 17.39 12.381 51.8 51.8 0 0 1 10.931 18.302 51.7 51.7 0 0 1-3.491 41.542 51.9 51.9 0 0 1-13.832 16.235 52.1 52.1 0 0 1-19.214 9.328 52.2 52.2 0 0 1-21.356.845l8.655-51.141z"
    />
    <path
      fill="var(--dataviz-color-sequential-blue-scale02)"
      d="M24.747 94.507a51.97 51.97 0 0 1 1.562-49.769l44.818 26.316z"
    />
    <path
      fill="var(--dataviz-color-sequential-blue-scale03)"
      stroke="var(--dataviz-color-sequential-blue-scale05)"
      strokeDasharray="6 6"
      strokeWidth={2}
      d="M45.01 116.005a51.968 51.968 0 0 1-15.473-76.35l41.459 31.34z"
    />
    <path
      fill="var(--dataviz-color-sequential-blue-scale02)"
      stroke="var(--dataviz-color-sequential-blue-scale05)"
      strokeDasharray="6 6"
      strokeWidth={2}
      d="M116.006 96.982a51.965 51.965 0 0 1-51.793 25.542 52 52 0 0 1-19.202-6.519l25.986-45.009z"
    />
    <path
      fill="var(--dataviz-color-sequential-blue-scale01)"
      stroke="var(--dataviz-color-sequential-blue-scale05)"
      strokeDasharray="6 6"
      strokeWidth={2}
      d="M25.988 45.01A51.97 51.97 0 0 1 71.69 19.028l-.694 51.968-45.01-25.986Z"
    />
  </svg>
);
export default SvgEmptyPie;
